import React from "react";
import { InputLabel, Input, IconButton, TextField } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useTranslation } from "react-i18next";
import { get } from "lodash";
import useStyles from "./styles";
import { isObject, isString } from "util";
import LoadingWidget from "../../widgets/LoadingWidget";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import UploadIcon from "Assets/images/message-icons/upload.svg";

const UploadButton = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    id,
    value = "",
    placeholder,
    btnText,
    accept,
    name,
    error,
    icon: Icon,
    loader,
    showLabel = true,
    buttonText,
    imagePreview,
    ...otherProps
  } = props;
  let errorMessage;

  if (isObject(error)) {
    errorMessage = get(props, `error[${props.name}]`, "");
  } else if (isString(error)) {
    errorMessage = get(props, "error", "");
  } else {
    errorMessage = "";
  }
  let disableElementStyle = props.disabled ? classes.disableElement : "";

  return (
    <div
      data-testid="focus"
      className={`${classes.root} ${disableElementStyle}`}
      onFocus={props.onFocus}
    >
      <p className={classes.uploadBtnLabel}>{btnText}</p>
      {!loader && (
        <Input
          {...otherProps}
          id={id}
          name={name}
          inputProps={{
            accept,
          }}
          className={classes.input}
        />
      )}
      <InputLabel htmlFor={id} className={showLabel ? classes.inputLabel : ""}>
        <IconButton
          data-testid="icon"
          color="primary"
          aria-label={
            props.ariaLabel ? props.ariaLabel : t("addEditUser.upload")
          }
          component="span"
        >
          {loader ? <LoadingWidget color="gray" /> : <img src={UploadIcon} />}
        </IconButton>
        {props.showName && (
          <TextField
            disabled={true}
            name={name}
            key={name}
            value={props.value ? props.value : value}
            placeholder={placeholder}
            className={classes.uploadBtnTxt}
            InputProps={
              ({
                startAdornment: (
                  <InputAdornment position="start">
                    {imagePreview ? <img src={imagePreview} width="30" /> : ""}
                  </InputAdornment>
                ),
              },
                { "data-testid": "field" })
            }
          />
        )}
        {showLabel ? (
          <span className={classes.btnLabel}>{buttonText}</span>
        ) : null}
      </InputLabel>
      {errorMessage ? (
        <span className={classes.errorMessages}>
          <ReportProblemOutlinedIcon />
          {errorMessage}
        </span>
      ) : null}
    </div>
  );
};

export default UploadButton;
